import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

const HotelDetail = ({
  hotelUpdateItem,
  timezoneItems,
  history,
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>{t('content_title.hotel_detail')}</h3>
      </div>
      <div className='content-title'></div>
      <div className='form-card detail'>
        <div className='form-card-title detail'>
        </div>
        <div className='inline-flex'>
          <div className='w-50'>
            <div className='card-text'>
              <p>
                <b>{t('data_column.hotel_name')}</b>
                <span className='required'>*</span>
              </p>
              <input
                className='card-text-input'
                placeholder={t('placeholder.hotel_name')}
                value={hotelUpdateItem.name}
                disabled
              />
            </div>
            <div className='card-text'>
              <p>
                <b>{t('data_column.timezone')}</b>
                {/* <span className='required'>*</span> */}
              </p>
              <select
                className='card-text-select'
                value={hotelUpdateItem.timezone}
                disabled
              >
                {timezoneItems.map((timezoneItem, index) => (
                  <option key={index} value={timezoneItem.code}>{timezoneItem.code}</option>
                ))}
              </select>
            </div>
            <div className='card-text'>
              <p>
                <b>{t('data_column.address')}</b>
              </p>
              <input
                className='card-text-input'
                placeholder={t('placeholder.address')}
                value={hotelUpdateItem.address}
                disabled
              />
            </div>
            <div className='card-text'>
              <p>
                <b>{t('data_column.description')}</b>
              </p>
              <input
                className='card-text-input'
                placeholder={t('placeholder.description_hotel')}
                value={hotelUpdateItem.desc}
                disabled
              />
            </div>
            <div className='card-text'>
              <p>
                <b>{t('data_column.pincode_day_type_offset')}</b>
                {/* <span className='required'>*</span> */}
              </p>
              <select
                className='card-text-select'
                value={hotelUpdateItem.pincodeDayTypeOffset}
                disabled
              >
                {new Array(24).fill().map((value, index) => (
                  <option
                    key={index}
                    label={index < 10 ? `0${index}:00` : `${index}:00`}
                    value={index < 10 ? `0${index}00` : `${index}00`}
                  />
                ))}
              </select>
            </div>
          </div>
          <div className='w-50'>
            <div className='card-box detail'>
              <p>
                <b>{t('data_column.commonroom_name')}</b>
              </p>
              <div className='card-box-text-container detail'>
                {hotelUpdateItem.commonrooms.map((commonroom, index) => (
                  <div className='card-box-text' key={index}>
                    <input
                      className='card-text-input'
                      placeholder={t('placeholder.commonroom_name')}
                      value={commonroom.name}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className='card-foot'></div>
      </div>
    </Fragment>
  );
};

export default HotelDetail;